import React, {
	useState, useEffect
}from "react"

import {
	Form, Modal, Input, Button, Row
}from "antd"
import {
	mobileActions
}from "../store/actions"
import {
	useDispatch, useSelector
}from "react-redux"
import Bowser from 'bowser'
import IdProf from "../../Profile/identificationNumber"
import LocalLoading from "../../../components/Loading/Local"
import notice from "../../../components/Notice"
import i18n from "../localization"

import "antd/lib/modal/style/index.css"
import {
	CustomInput
}from "../../../components/CustomInput"
import CustomButton from "../../../components/ButtonCustom"
import './style.css'

//seconds; should be similar with appsettings.json;
const _time = 60

const ConfirmMobile = (props) => {
	const {
		mobilePhoneNumber,
		phoneCode,
		reOrgId,
		setVisible,
		onSuccess,
		сloseButtonVisible,
		visible
	} = props
	const dispatch = useDispatch()
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const { isCodeSended, sendCodeError, changeNumberLoading } = useSelector((state) => state.mobileReducer)
	const [disabled, setDisabled] = useState(true)
	const [IsRepeated, setIsRepeated] = useState(false)
	const [time, setTime] = useState(_time)

	useEffect(() => {
		if (visible && !isCodeSended)
			sendCode()
	}, [visible])

	useEffect(() => {
		if (isCodeSended && !IsRepeated)
			createTimeout()
	}, [isCodeSended])
	useEffect(() => {
    if (!visible) dispatch(mobileActions.clearCodeSended());
  }, [visible]);

	useEffect(() => {
		/*  if (sendCodeError && visible) {
		    notice("error", sendCodeError.errors);
		     setVisible(false);
		   } */
	}, [sendCodeError])
	function createTimeout(){
		const timerId = setInterval(() => setTime((prevTime) => prevTime - 1), 1000)
		setTimeout(() => {
			clearInterval(timerId)
			setDisabled(false)
			setTime(0)
		}, _time * 1000)
	}

	const repeat = () => {
		sendCode()
		setDisabled(true)
		setIsRepeated(true)
		setTime(_time)
		createTimeout()
	}

	const sendCode = () => {
		dispatch(mobileActions.sendCode({
			mobilePhoneNumber,
			phoneCode,
			toConfirm: true
		}))
	}

	const onFinish = (values) => {
		onSuccess(values.code)
	}
	return (
		<Modal

			// closable={ сloseButtonVisible }
			destroyOnClose
			footer={ null }
			title={ i18n.confirmPhone[isRu] }
			visible={ visible }
			width={ 800 }
			onCancel={ () => {
				setVisible(false)
			} }
		>
			{ isCodeSended ? (
				<Row justify="center">
					<Form
						className={
							Bowser.name === 'Internet Explorer' && Bowser.version === '11.0'
								? 'ie-view-fix'
								: ''
						}
						name="phoneConfirm"
						onFinish={ onFinish }
					>
						{ phoneCode ? (
							<div className="code-phone-text">
								<span>
									{ i18n.confirmTextPhone[isRu].format((phoneCode.Value ?? phoneCode.value) + mobilePhoneNumber) }
								</span>
								<span>
									{ i18n.confirmTextInputBold[isRu] }
								</span>
								<span>
									{ i18n.confirmTextRepeat[isRu](time == 0).format(time) }
								</span>
							</div>
						) : null }
						<Form.Item
							name="code"
							rules={ [
								{
									required : true,
									message  : i18n.requiredField[isRu]
								}
							] }
						>
							<CustomInput
								autoComplete="off"
								className="phone-code"
								placeholder={ i18n.confirmInputPlaceHolder[isRu] }
							/>
						</Form.Item>
						{ /* {reOrgId ? (
							<CustomButton
							key="repeat"
							disabled={disabled}
							type="grey"
							onClick={() => repeat()}
						>
							{i18n.repeatCode[isRu][0]}
						</CustomButton>
						) : null} */ }
						<Form.Item>
							<CustomButton
								key="repeat"
								disabled={ disabled }
								type="grey"
								onClick={ () => repeat() }
							>
								{ i18n.repeatCode[isRu][0] }
							</CustomButton>
							<CustomButton
								htmlType="submit"
								loading={ changeNumberLoading }
								type="orange"
							>
								{ i18n.confirmPhoneNumber[isRu] }
							</CustomButton>

						</Form.Item>
					</Form>
				</Row>
			) : (
				<LocalLoading text={ i18n.codeLoading[isRu] } />
			) }
		</Modal>
	)
}

export default ConfirmMobile
